<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content overflowShadow>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+SRC_COMMISSIONINGV2.SELECT_HC_SUBTITLE' | translate }}
        </div>

        <span class="description-section__channels-wrapper" [ngSwitch]="assignHcStateLoadingState">
          <ng-container *ngSwitchCase="AssignHcState.AssignHc">
            <div class="description-section__channels" #overflowShadowObservedElement>
              <ng-container
                *ngIf="
                  deviceType === remoteDeviceTypeValues.VITOTROL_300E;
                  else notRemoteHeatingCircuits
                "
              >
                <ng-container *ngIf="remoteCircuits.length; else noHeatingCircuitRemote">
                  <div class="description-section__channels" #overflowShadowObservedElement>
                    <mat-radio-group
                      class="hc-selection__radio-group"
                      [ngModel]="selectedFeatureOption"
                      (ngModelChange)="onHcOptionSelect($event)"
                    >
                      <mat-radio-button
                        *ngFor="let circuit of remoteCircuits; index as i"
                        color="primary"
                        [value]="circuit"
                      >
                        <span class="radio__name">
                          {{ i + 1
                          }}{{ installationService.getCircuitName(circuit.feature) | async }}
                        </span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </ng-container>
                <ng-template #noHeatingCircuitRemote>
                  <app-banner type="warning">
                    {{ '+SRC_COMMISSIONINGV2.ASSIGN_HC_NO_HEATING_CIRCUITS' | translate }}
                  </app-banner>
                </ng-template>
              </ng-container>

              <ng-template #notRemoteHeatingCircuits>
                <mat-radio-group
                  *ngIf="allCircuits | ready as circuits"
                  class="hc-selection__radio-group"
                  [ngModel]="selectedNumericOption + ''"
                  (ngModelChange)="onHcOptionSelect($event)"
                >
                  <mat-radio-button
                    *ngFor="let circuit of circuits | featureValue: 'enabled'"
                    color="primary"
                    [value]="circuit"
                  >
                    <span class="radio__name">
                      {{ installationService.getCircuitName(circuit) | async }}
                    </span>
                  </mat-radio-button>
                </mat-radio-group>
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="AssignHcState.Loading">
            <app-banner type="info">
              {{ '+SRC_COMMISSIONINGV2.ASSIGN_HC_LOADING_HC' | translate }}
            </app-banner>
          </ng-container>
          <ng-container *ngSwitchCase="AssignHcState.ErrorNoHeatingCircuits">
            <app-banner type="warning">
              {{ '+SRC_COMMISSIONINGV2.ASSIGN_HC_NO_HEATING_CIRCUITS' | translate }}
            </app-banner>
          </ng-container>
        </span>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="assignHcModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="Next step"
      gtmCategory="assignHcModal"
      mat-raised-button
      color="primary"
      [disabled]="!canNavigateForward()"
      (click)="navigateForward()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
